<div class="ideals-default-bg__container ideals-default-bg" [ngClass]="defaultBackgroundClass">
  <ng-content></ng-content>
</div>
